import logo from '../images/logo-keralty.png';
import { Link } from 'react-router-dom';
import { useState, useRef } from 'react';

function Header() {
    const [isAboutOpen, setIsAboutOpen] = useState(false);
    const closeTimeout = useRef(null);

    const openMenu = () => {
        if (closeTimeout.current) {
            clearTimeout(closeTimeout.current);
            closeTimeout.current = null;
        }
        setIsAboutOpen(true);
    };

    const scheduleCloseMenu = () => {
        // tempo pequeno pra cobrir pequenas perdas de hover (ajusta se quiser)
        closeTimeout.current = setTimeout(() => {
            setIsAboutOpen(false);
            closeTimeout.current = null;
        }, 150);
    };



    return (
        <div className="fixed top-0 left-0 w-full bg-white z-10 shadow-md flex justify-center h-20">
            <div className="container hidden lg:flex justify-evenly items-center px-6 py-4">

                {/* Logo no canto esquerdo */}
                <div className="w-[220px] ml-4">
                    <img data-aos="fade-right" data-aos-duration="1000" alt="Logo Keralty" src={logo} />
                </div>

                {/* Menu Centralizado */}
                <div className="flex justify-center items-center">
                    <div className="flex justify-evenly font-rubik w-full max-w-lg p-2 min-w-[700px] rounded-full items-center border-second gap-10">
                        <Link
                            to="/#top"
                            className="text-1xl hover:text-primary transition ease-in-out text-second"
                        >
                            Home
                        </Link>
                        <Link
                            to="/about"
                            className="text-1xl hover:text-primary transition ease-in-out text-second"
                        >
                            Sobre nós
                        </Link>
                        <div className="relative">
                            {/* Botão - mantemos handlers também aqui */}
                            <button
                                onMouseEnter={openMenu}
                                onMouseLeave={scheduleCloseMenu}
                                className="text-1xl hover:text-primary transition ease-in-out text-second"
                            >
                                Voluntariado
                            </button>

                            {/* SUBMENU — também com handlers para garantir que ao hover sobre ele o menu fique aberto */}
                            {isAboutOpen && (
                                <div
                                    onMouseEnter={openMenu}
                                    onMouseLeave={scheduleCloseMenu}
                                    className="absolute left-0 top-full flex flex-col bg-white shadow-lg rounded-md mt-2 w-48 z-20"
                                >
                                    <Link
                                        to="/volunteer/corrente-do-bem"
                                        className="block px-4 py-2 text-second hover:bg-gray-100 hover:text-primary transition"
                                    >
                                        Corrente do Bem
                                    </Link>
                                    <Link
                                        to="/volunteer/musicos"
                                        className="block px-4 py-2 text-second hover:bg-gray-100 hover:text-primary transition"
                                    >
                                        Músicos
                                    </Link>
                                    <Link
                                        to="/volunteer/palhacaria"
                                        className="block px-4 py-2 text-second hover:bg-gray-100 hover:text-primary transition"
                                    >
                                        Palhaçaria
                                    </Link>
                                    <Link
                                        to="/volunteer/criancas-atipicas"
                                        className="block px-4 py-2 text-second hover:bg-gray-100 hover:text-primary transition"
                                    >
                                        Crianças Atípicas
                                    </Link>
                                    <Link
                                        to="/volunteer/cuidados-paliativos"
                                        className="block px-4 py-2 text-second hover:bg-gray-100 hover:text-primary transition"
                                    >
                                        Cuidados Paliativos
                                    </Link>
                                    <Link
                                        to="/volunteer/casa-de-repouso"
                                        className="block px-4 py-2 text-second hover:bg-gray-100 hover:text-primary transition"
                                    >
                                        Casa de Repouso
                                    </Link>
                                </div>
                            )}
                        </div>
                        <Link
                            to="/transparency"
                            className="text-1xl hover:text-primary transition ease-in-out text-second"
                        >
                            Transparência
                        </Link>
                        <Link
                            to="/abraca-keralty"
                            className="text-1xl bg-primary p-3 text-white rounded hover:text-primary hover:bg-gray-100 transition ease-in-out text-second"
                        >
                            Abraça Keralty
                        </Link>
                        
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Header;
